import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@/components/ui/accordion';
import { Reveal } from '@/components/Reveal';
import { HOME } from '@/constants/testIds';

const FAQS = [
    {
        q: 'What is ENGINE?',
        a: 'ENGINE is a voice-controlled Studio Copilot for FL Studio. It listens for a wake phrase and carries out voice commands so you can keep your focus on the music.',
    },
    {
        q: 'Does ENGINE work offline?',
        a: 'Yes. Voice recognition runs offline — no connection required, and the session never waits on the network.',
    },
    {
        q: 'What are the wake phrases?',
        a: '“Engineer” or “Engine.” Either phrase wakes ENGINE, even mid-session.',
    },
    {
        q: 'Is the wake chime required?',
        a: 'No. The chime is optional — a soft confirmation tone you can turn on or off to suit the room.',
    },
    {
        q: 'How much does ENGINE cost?',
        a: '$4.99, one-time purchase. No subscription.',
    },
    {
        q: 'Where can I buy ENGINE?',
        a: 'ENGINE will be sold through our Shopify storefront, with checkout and digital-download delivery handled by Shopify. The Get ENGINE buttons currently point to a placeholder checkout.',
    },
];

export const Faq = () => (
    <section id="faq" data-testid={HOME.faq} className="relative py-24 md:py-32">
        <div className="mx-auto max-w-3xl px-6">
            <Reveal>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-aqua">FAQ</p>
                <h2 className="mt-4 text-3xl font-light tracking-tight sm:text-4xl">Short answers.</h2>
            </Reveal>

            <Reveal delay={0.1}>
                <Accordion type="single" collapsible className="mt-10">
                    {FAQS.map((item, i) => (
                        <AccordionItem key={item.q} value={`item-${i}`} className="border-white/10">
                            <AccordionTrigger
                                data-testid={`faq-item-${i + 1}`}
                                className="py-6 text-left text-base font-normal text-zinc-200 hover:text-white hover:no-underline"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-sm leading-relaxed text-zinc-400">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
